import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import GoalValidations from 'scaleflow/validators/goal';

export default class GoalsGoalSummaryPanelComponent extends Component {
  @service router;

  @tracked tippyInstance;

  goalValidations = GoalValidations;

  @action
  editGoal() {
    this.router.transitionTo('business.goals.goal.edit', this.args.goal.id);
  }

  @action
  setTippyInstance(instance) {
    this.tippyInstance = instance;
  }
}
